import { useSelector } from 'react-redux';
import { getRefundInfoState, getUnvoluntaryReasons } from '../model/refundInfo/selectors';
export const useSkipReasons = () => {
    const refundInfo = useSelector(getRefundInfoState);
    const unvoluntaryReasons = useSelector(getUnvoluntaryReasons);
    const isRefundInfoLoaded = Boolean(refundInfo);
    return isRefundInfoLoaded && unvoluntaryReasons.length === 0;
};
